import { Fragment } from 'react'
import { Link, usePath } from '../router.js'
import { breadcrumbFor } from './site-navigation.js'

/**
 * FIL D'ARIANE CANONIQUE (IA V2.1, §22-23) — Famille › Module › Fonction,
 * depuis le registre. Il navigue vers les PARENTS de la taxonomie ; il ne
 * prétend jamais revenir dans l'historique (ça, c'est SmartBack).
 */
export function Trail({ leaf }: { leaf?: string }) {
  const path = usePath()
  const crumbs = breadcrumbFor(path)
  return (
    <nav className="lc-trail" aria-label="Fil d’Ariane">
      {crumbs.map((c, i) => (
        <Fragment key={i}>
          {i > 0 ? <span className="lc-trail__sep" aria-hidden="true">›</span> : null}
          {c.route ? <Link href={c.route} className="lc-trail__link">{c.label}</Link>
            : <span className="lc-trail__here">{c.label}</span>}
        </Fragment>
      ))}
      {leaf ? (<><span className="lc-trail__sep" aria-hidden="true">›</span><span className="lc-trail__here">{leaf}</span></>) : null}
    </nav>
  )
}
